import { firestore } from 'firebase/app'
import { FirestoreQuery } from '../Firestore/FirestoreQuery'
import { UserSetting } from './UserSetting'
import { UserSettingMapper } from './UserSettingMapper'

export class UserSettingCollection {
  protected collection: string = 'userSetting'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  watchUserSetting(id: string): { data: UserSetting | null } {
    const query = this.initQuery()
    return query.watch(id)
  }

  getUserSetting(id: string): Promise<UserSetting | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  async getUserSettingByUserId(userId: string): Promise<UserSetting | null> {
    const query = this.initQuery()
    query.setQuery(this.getUserSettingsByUserIdQuery(query, userId).limit(1))
    const userSettings = await query.list()
    return userSettings.length ? userSettings[0] : null
  }

  save(userSetting: UserSetting): Promise<UserSetting> {
    const query = this.initQuery()
    return query.save(userSetting)
  }

  delete(userSetting: UserSetting) {
    const query = this.initQuery();
    return query.delete(userSetting)
  }

  protected initQuery(): FirestoreQuery<UserSetting> {
    const query = new FirestoreQuery<UserSetting>(this.db, new UserSettingMapper())
    query.collection(this.collection)

    return query
  }

  protected getUserSettingsByUserIdQuery(query: FirestoreQuery<UserSetting>, userId: string) {
    return this.getUserSettingsByFieldValue(query, 'userId', userId)
  }

  protected getUserSettingsByFieldValue(query: FirestoreQuery<UserSetting>, field: string, value: any) {
    return query.collection(this.collection).where(field, '==', value)
  }
}
